import React, {Component} from 'react';
import {Button, Modal, Form, Grid} from 'semantic-ui-react';
import update from 'react-addons-update';

import BranchOfficeData from "../../data/BranchOfficeData";
import SectionData from "../../data/SectionData";
import Toast from "../extras/Toast";
import {showToast} from "../../actions/ToastAction";
import connect from "react-redux/es/connect/connect";
import {sectionDialog} from "../../actions/SectionDialogAction";
import {selectSection} from "../../actions/SectionSelectAction";

class SectionDialog extends Component {

    constructor(props) {
        super(props);

        this.state = {
            open: false,
            title: "",
            label_button: " ",
            section: {
                name: '',
                id: null,
                branch_office: {
                    id: '',
                    name: ''
                }
            },
            branch_offices: [],
            branch_office_error: false,
            name_error: false,
            index: null,
            sending: false
        };

        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleBranchOfficeChange = this.handleBranchOfficeChange.bind(this);
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.section_dialog){
            this.setState({section:nextProps.section_dialog.section});
        }
    }

    updateLabels = (section, index) => {
        if (section) {
            this.setState({
                title: "Actualizar sección",
                label_button: "Actualizar información",
                section: section,
                index: index
            });
        } else {
            this.setState({
                title: "Nueva sección",
                label_button: "Guardar información",
                name_error: false,
                branch_office_error: false,
                section: {
                    name: "",
                    id: null,
                    branch_office: {
                        id: '',
                        name: ''
                    }
                }
            });
        }
    };

    componentDidMount() {
        this.getBranchOffices();
    }

    async getBranchOffices() {
        let branch_offices = await BranchOfficeData.listAll();
        this.setState({branch_offices})
    }

    handleBranchOfficeChange = (result) => {
        let branch_office = update(this.state, {
            section: {
                branch_office: {
                    id: {
                        $set: result
                    },
                    name: {
                        $set: result
                    }
                }
            }
        });
        this.setState(branch_office);
        this.setState({branch_office_error: false})
    };

    handleNameChange = (event) => {
        let name = update(this.state, {
            section: {
                name: {
                    $set: event.target.value
                }
            }
        });
        this.setState(name);
        if (event.target.value.trim() === '') {
            this.setState({name_error: true})
        } else {
            this.setState({name_error: false});
        }
    };

    async handleSubmit(event) {
        event.preventDefault();
        if (this.state.section.branch_office.id === null ) {
            this.setState({branch_office_error: true});
        }
        else if (this.state.section.name === '') {
            this.setState({name_error: true});
        } else {
            this.setState({sending: true});
            if (this.state.section.id) {
                SectionData.update(this.state.section, (res) => {
                    if (res !== null && res.hasOwnProperty('id')) {
                        this.dispatchData(res, 'Sección Actualizada!', 'success');
                    } else {
                        this.props.showToast({message: 'Tenemos un problema, inténtalo más tarde!', type: 'error'});
                    }
                    this.setState({sending: false});
                });
            } else {
                SectionData.add(this.state.section, (res) => {
                    if (res !== null && res.hasOwnProperty('id')) {
                        this.dispatchData(res, 'Sección Agregada!', 'success');
                    } else {
                        this.props.showToast({message: 'Tenemos un problema, inténtalo más tarde!', type: 'error'});
                    }
                    this.setState({sending: false});
                });
            }
        }
    };

    handleClose = () => {
        this.props.sectionDialog({open: false, section:{id:null, name:'', branch_office:{id:null}}});
    };

    dispatchData = (section, message, type) => {
        this.props.selectSection(section);
        this.props.sectionDialog({open:false, section:{id: null, name: '', branch_office:''}});
        this.props.showToast({message, type});
    };

    render() {
        return (
            <div>
                <Modal size='tiny' open={this.props.section_dialog.open} onClose={this.handleClose} dimmer='inverted'>
                    <Modal.Header>{this.props.section_dialog.section.id ? 'Actualizar Sección':'Nueva Sección'}</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <Form onSubmit={this.handleSubmit}>
                                <Grid>
                                    <Grid.Row>
                                        <Grid.Column>
                                            <Form.Select label='Sucursal' options={this.state.branch_offices}
                                                         onChange={(e, {value}) => this.handleBranchOfficeChange(value)}
                                                         value={this.state.section.branch_office.id}
                                                         placeholder='Sucursal' error={this.state.branch_office_error}/>
                                            <Form.Input label='Nombre' placeholder='Nombre'
                                                        value={this.state.section.name} onChange={this.handleNameChange}
                                                        error={this.state.name_error}/>
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                            </Form>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button icon='x' labelPosition='left' onClick={this.handleClose} content="Cancelar"/>
                        <Button primary icon='save' labelPosition='left' onClick={this.handleSubmit}
                                content={this.props.section_dialog.section.id ? 'Actualizar':'Guardar'} loading={this.state.sending} disabled={this.state.sending}/>
                    </Modal.Actions>
                </Modal>
                <Toast ref='toast'/>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        section_dialog: state.get('section_dialog'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        sectionDialog(data) {
            dispatch(sectionDialog(data));
        },
        showToast(data){
            dispatch(showToast(data))
        },
        selectSection(data){
            dispatch(selectSection(data))
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SectionDialog);


// WEBPACK FOOTER //
// ./src/components/my_bisttro/SectionDialog.js